
/**
 * Centralizador de Configurações
 * Resolve variáveis de ambiente priorizando o window.__ENV__ (Runtime/env.js)
 * seguido por import.meta.env (Vite/Build), e finally hardcoded fallbacks.
 */

interface AppConfig {
  supabaseUrl: string;
  supabaseAnonKey: string;
  googleMapsKey: string;
}

declare global {
  interface Window {
    __ENV__?: {
      VITE_SUPABASE_URL?: string;
      VITE_SUPABASE_ANON_KEY?: string;
      VITE_GOOGLE_GEOCODING_API_KEY?: string;
      VITE_GOOGLE_MAPS_API_KEY?: string;
    };
  }
}

// Fallback values from .env provided in context to ensure startup
const FALLBACK_CONFIG = {
  VITE_SUPABASE_URL: "https://ibsbxnpaiqcmcmxzvdtf.supabase.co",
  VITE_SUPABASE_ANON_KEY: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imlic2J4bnBhaXFjbWNteHp2ZHRmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjY3NzI0OTAsImV4cCI6MjA4MjM0ODQ5MH0.JNAV5Uz9XnrxZpvEzA4Vn-7S_IkL-GH6QDhw5c2xSAE",
  VITE_GOOGLE_GEOCODING_API_KEY: "AIzaSyCo6qilaTA-n68U9Ok7-jwu6tSCbF36_jg"
};

const isPlaceholder = (val?: string) => {
  if (!val) return true;
  return val.includes('seu-projeto') || val.includes('sua-chave') || val.includes('your-anon-key');
};

const resolveConfig = (): AppConfig => {
  const runtime = typeof window !== 'undefined' ? window.__ENV__ || {} : {};
  
  let viteEnv: any = {};
  try {
    // @ts-ignore
    if (typeof import.meta !== 'undefined' && import.meta.env) {
        // @ts-ignore
        viteEnv = import.meta.env;
    }
  } catch (e) {
    console.warn('[Config] Error reading import.meta.env', e);
  }

  // Helper para buscar variável válida (ignora placeholders)
  const getVar = (keys: string[], fallback: string) => {
      // 1. Tenta Runtime (env.js)
      for (const key of keys) {
          // @ts-ignore
          const val = runtime[key];
          if (val && !isPlaceholder(val)) return val;
      }
      
      // 2. Tenta Vite Env (.env)
      for (const key of keys) {
          const val = viteEnv[key];
          if (val && !isPlaceholder(val)) return val;
      }
      
      return fallback;
  };

  const config = {
    supabaseUrl: getVar(['VITE_SUPABASE_URL'], FALLBACK_CONFIG.VITE_SUPABASE_URL).trim(),
    supabaseAnonKey: getVar(['VITE_SUPABASE_ANON_KEY'], FALLBACK_CONFIG.VITE_SUPABASE_ANON_KEY).trim(),
    googleMapsKey: getVar(['VITE_GOOGLE_GEOCODING_API_KEY', 'VITE_GOOGLE_MAPS_API_KEY'], FALLBACK_CONFIG.VITE_GOOGLE_GEOCODING_API_KEY).trim()
  };

  // Log de segurança
  if (!config.supabaseUrl || !config.supabaseAnonKey) {
    console.error(
      `[Config] CRITICAL: Supabase credentials missing.\n` +
      `URL Present: ${!!config.supabaseUrl}\n` +
      `Key Present: ${!!config.supabaseAnonKey}`
    );
  } else {
    // Log discreto de sucesso no carregamento
    console.log('[Config] Loaded successfully', { 
        url: config.supabaseUrl, 
        mapsKeyPrefix: config.googleMapsKey.substring(0, 8) + '...' 
    });
  }

  return config;
};

export const CONFIG = resolveConfig();
